<template>
  <div >
    <v-layout row wrap>
      <v-flex >
        <v-card class="primary white--text" height="200px">
          <v-container fluid grid-list-lg>
            <v-layout row>
              <v-flex xs5>
                <wz-avatar :src="userAvatar + '?' + Math.random()" :username="fullName" size="128px"></wz-avatar>
              </v-flex>
              <v-flex xs7>
                <div>
                  <div class="headline">{{ fullName }}</div>
                  <div>{{ account.type }}</div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- </v-img> -->
        </v-card>
        
        <v-card>
          <!-- Bouton de modification du profil -->
          <v-card-text style="padding: 0px; position: relative">
            <v-fab-transition>
              <v-btn
                color="secondary"
                dark
                absolute
                bottom
                right
                fab
                v-show="showFab"
                @click.native.stop="openDialog()"
              >
                <v-icon >edit</v-icon>
              </v-btn>
            </v-fab-transition>
          </v-card-text>
        </v-card>

        <v-expansion-panel v-model="panel" expand>
          <v-expansion-panel-content >
            <template v-slot:header>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title >{{ $t('yourInfos') | cap }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
            <v-card>
              <v-card-text>
                <!-- Infos de l'utilisateur -->
                <v-list two-line dense>
                  <v-list-tile v-if="user.job">
                    <v-list-tile-action>
                      <v-icon class="primary--text">assignment_ind</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.job }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('job') | cap }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="primary--text">mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.mail }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('loginEmail') | cap }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="user.mailContact">
                    <v-list-tile-action>
                      <v-icon class="primary--text">mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.mailContact }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ $t('contactEmail') | cap }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider inset v-if="user.phone"></v-divider>
                  <v-list-tile v-if="user.phone">
                    <v-list-tile-action>
                      <v-icon class="primary--text">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.phone }}</v-list-tile-title>
                      <v-list-tile-sub-title>({{ user.ios ? 'IOS' : 'non IOS' }})</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content v-if="!isLevelFaq() && hideShowNotifButton">
            <template v-slot:header>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title >{{ $t('NotifTitle') | cap }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('NotifContent') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
            <v-card>
              <v-card-text>
                <v-card-title>
                  {{  $t('MyPhoneContent') }}
                </v-card-title>
                <v-card-actions>

                  <v-btn
                    color="primary"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click.native="souscriptionPush()"
                    :disabled="!souscriptionBtn"
                    
                  >{{souscriptionBtnTxt}}
                    <v-icon dark right>notifications</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-card-actions>
                  <section
                    v-if="isSubscribed"
                    class="subscription-details js-subscription-details "
                  >
                  <!--
                    <p>Once you've subscribed your user, you'd send their subscription to your
                    server to store in a database so that when you want to send a message
                    you can lookup the subscription and send a message to it.</p>
                    <p>To simplify things for this code lab copy the following details
                    into the <a href="https://web-push-codelab.glitch.me//">Push Companion
                    Site</a> and it'll send a push message for you, using the application
                    server keys on the site - so make sure they match.</p>
                    <pre><code class="js-subscription-json">{{subscriptionDetail}}</code></pre>
                  </section>

                  <section>
                    <h3>Application Server Keys</h3>
                    <p>Application server keys are used to idenitfy your application server
                      with a push service.</p>

                    <p><strong>Public Key</strong>
                    <pre><code class="js-public-key">Loading...</code></pre>
                    </p>
                    <p><strong>Private Key</strong>
                    <pre><code class="js-private-key">Loading...</code></pre>
                    </p>

                    <p>
                      <v-btn
                            color="primary"
                            flat
                            dark
                            :block="$vuetify.breakpoint.xsOnly"
                            @click.native="getNewKey()"
                            :disabled="!refreshBtn"
                          >Refresh Keys
                          <v-icon class="primary--text" right>settings_backup_restore</v-icon>
                      </v-btn>
                    </p>
                        -->
                    <p>
                      <v-btn
                            color="primary"
                            flat
                            dark
                            :block="$vuetify.breakpoint.xsOnly"
                            @click.native="sendNotif()"
                          >{{testNotifBtnTxt}}
                          <v-icon class="primary--text" right>send</v-icon>
                      </v-btn>
                    </p>
                  </section>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content v-if="!isLevelFaq()">
            <template v-slot:header>
              <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title >{{ $t('editFicheLayout') }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              <!--<v-subheader>{{ $t('editFicheLayout') }}</v-subheader>-->
            </template>
            <wz-choose-layout-fiche-visiteur
              v-if="account.role !== 'admin'"
            ></wz-choose-layout-fiche-visiteur>
          </v-expansion-panel-content>

        </v-expansion-panel>


        
      </v-flex>
    </v-layout>

    <!-- DIALOGUE D'ÉDITION DU PROFIL -->
    <v-dialog
      v-model="dialog"
      persistent
      width="600px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="primary white--text"  style="height: 76px;">
          <v-btn v-if="$vuetify.breakpoint.smAndDown" icon @click="cancel()"><v-icon class="white--text">close</v-icon></v-btn>
          <span class="title">{{ $t('editProfil') }}</span>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" @click="save()">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text :style="{'heightOfCard': !$vuetify.breakpoint.smAndDown}">
          <wz-img-upload @change="saveImg" :disabled="imgLoading"></wz-img-upload>
          <!-- Civilité -->
          <!-- <wz-select-gender :gender.sync="userDialog.title"></wz-select-gender> -->
          <v-text-field 
            v-model="userDialog.fname" 
            :label="$t('firstName') | cap"
            type="text" 
            prepend-icon="accessibility"
          ></v-text-field>
          <v-text-field 
            v-model="userDialog.lname" 
            :label="$t('lastName') | cap"
            type="text" 
            prepend-icon="accessibility"
          ></v-text-field>
          <v-text-field 
            v-model="userDialog.job" 
            :label="$t('job') | cap"
            type="text" 
            prepend-icon="assignment_ind"
          ></v-text-field>
          <v-text-field 
            v-model="userDialog.mailContact" 
            :label="$t('email') | cap"
            type="email"
            prepend-icon="mail"
            data-vv-name="email"
            v-validate="'required|email'"
            :error="wzErrors.has('email')"
            :error-messages="wzErrors.collect('email')"
          ></v-text-field>
          <v-text-field 
            v-model="userDialog.phone" 
            :label="$t('mobilephone') | cap"
            type="telephone"
            prepend-icon="phone"
            :error="wzErrors.has('phone')"
            :error-messages="wzErrors.collect('phone')"
          ></v-text-field>
          <v-subheader 
            v-if="user.serviceSid != ''"
          >{{$t('MyPhoneOK') | cap}}</v-subheader>
          <v-checkbox
            v-if="user.serviceSid != ''"
            v-model="userDialog.ios" 
            :label="$t('MyPhone') | cap" 
            prepend-icon="phone_iphone"
          ></v-checkbox>
          <wz-switch-lang @change="updateLang"></wz-switch-lang>
        </v-card-text>
        <v-divider v-if="!$vuetify.breakpoint.smAndDown"></v-divider>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown">
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel()">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="save()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import permission from '../mixins/permissions'
import WzChooseLayoutFicheVisiteur from './watcheezy/WzChooseLayoutFicheVisiteur'
import _watcheebox from './watcheebox/watcheebox.js'

export default {
  mixins: [permission],
  components: {
    WzChooseLayoutFicheVisiteur
  },
  data () {
    return {
      phoneProps: {
        mode: 'international',
        options: {
          placeholder: this.$t('phone')
        }
      },
      panel: [true],
      name: 'Mon profil',
      // indique si la modification du profil est visible
      dialog: false,
      // objet user qui représente celui dans la fenêtre de dialogue
      userDialog: {title: ''},
      // Image Upload
      imgLoading: false,
      // Dialogue indiquant que l'utilisateur a fait une modification de ses infos
      dialogAlert: false,
      showFab: false,
      isSubscribed: false,
      swRegistration: null,
      applicationServerPublicKey: null,
      refreshBtn: false,
      souscriptionBtn: false,
      souscriptionBtnTxt: this.$t('disablePushMessaging'),
      subscriptionDetail: null,
      testNotifBtnTxt: this.$t('btnTestPushMessaging'),
      dialogProgress: false,
      hideShowNotifButton: true
    }
  },

  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'profile'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'profile'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  methods: {
    // récupération des mutateurs du store
    ...mapMutations('_User', ['setUser', 'setAvatar']),

    save () {
      // retire les espace du numéro de téléphone
      let numPhone = this.userDialog.phone.split(' ').join('')
      numPhone = numPhone.split('.').join('')
      numPhone = numPhone.split('-').join('')
      if (numPhone.substring(0, 2) === '06' || numPhone.substring(0, 2) === '07') {
        numPhone = '+33' + numPhone.substring(1)
      }
      console.log('this.userDialog', this.userDialog)
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('user_first_name', this.userDialog.fname)
      dataToPost.append('user_last_name', this.userDialog.lname)
      dataToPost.append('user_mail', this.userDialog.mail)
      dataToPost.append('user_mail_contact', this.userDialog.mailContact)
      dataToPost.append('user_title', this.userDialog.title)
      dataToPost.append('user_tel', numPhone)
      dataToPost.append('user_tel_ios', this.userDialog.ios ? '1' : '0')
      dataToPost.append('user_job', this.userDialog.job)
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_PROFILE')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_PROFILE'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      // update côté serveur
      // Si changement dans le formulaire alors on fait la requête afin de modifier les données en BDD
      if (!_.isEqual(this.user, this.userDialog)) { // comparaison entre ce que l'utilisateur actuellement géré par le store et celui du formulaire
        this.loading = true
        this.axios.post('put/user.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        // les changements été pris en compte alors changement des valeurs de l'user géré par le store
        .then(response => {
          let avatar = this.user.avatar
          this.setUser(_.clone(this.userDialog))
          this.setAvatar(avatar)
          this.$cookie.set('wz-lang', this.userDialog.lang, { expires: '1Y' })
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        })
        .catch(_ => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
          this.dialog = false
        })
      } else {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' })
      }
    },
    /**
     * Annule les modifications
     * si l'utilisateur en a déjà faite, l'interpeller
     */
    cancel () {
      this.dialog = false
    },
    openDialog () {
      this.dialog = true
      // clonage de l'utilisateur qui est dans le store
      this.userDialog = _.clone(this.user)
    },
    updateLang (newLang) {
      this.userDialog.lang = newLang
    },

    /**
     * Upload image sur le serveur
     * @return {[type]}     [description]
     */
    saveImg (filename) {
      // cas d'un fichier null => suppression de la photo de profil
      if (!filename) {
        this.deleteImg()
        return
      }
      this.imgLoading = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('url', filename)
      this.axios.post('put/user_picture.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // le changement de l'image a été pris en compte
      .then(response => {
        this.setAvatar(this.user.id + '_avatar.jpg')
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('SaveImgOK'), context: 'success' })
      })
      .catch(_ => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('SaveImgKO'), context: 'error' })
      })
      .then(_ => {
        this.imgLoading = false
      })
    },
    /**
     * Supprime l'image définie auparavant par l'utilisateur
     * côté serveur & client
     */
    deleteImg () {
      let dataToPost = new window.FormData()
      dataToPost.append('url', null)
      this.axios.post('put/user_picture.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.userDialog.avatar = null
        this.setAvatar(this.userDialog.avatar)
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('SupImg'), context: 'success' })
      })
      .catch(errors => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('SupImgKO'), context: 'error' })
      })
    },

    // ----------------------------------------------------------------------------
    // fonctions de souscription au webPush
    // ----------------------------------------------------------------------------
    initializeUI () {
      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription()
      .then((subscription) => {
        this.isSubscribed = !(subscription === null)
        this.updateSubscriptionOnServer(subscription)
        if (this.isSubscribed) {
          console.log('User IS subscribed.')
        } else {
          console.log('User is NOT subscribed.')
          this.subscribeUser()
        }
        this.updateBtn()
      })
    },

    updateBtn () {
      if (Notification.permission === 'denied') {
        this.souscriptionBtnTxt = this.$t('pushMessagingBlocked')
        this.souscriptionBtn = false
        this.updateSubscriptionOnServer(null)
        return
      }
      if (this.isSubscribed) {
        this.souscriptionBtnTxt = this.$t('disablePushMessaging')
      } else {
        this.souscriptionBtnTxt = this.$t('enablePushMessaging')
      }
      // pushButton.disabled = false
    },

    souscriptionPush () {
      if (this.isSubscribed) {
        this.unsubscribeUser()
      } else {
        this.subscribeUser()
      }
    },

    subscribeUser () {
      console.log('this.applicationServerPublicKey.public', this.applicationServerPublicKey.public)
      const applicationServerKey = this.base64UrlToUint8Array(this.applicationServerPublicKey.public)
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
      .then((subscription) => {
        console.log('User is subscribed.')
        this.updateSubscriptionOnServer(subscription)
        this.isSubscribed = true
        this.updateBtn()
        // -----------------------------------
        // sauve les clés dans redis via nodejs.
        // -----------------------------------
        _watcheebox.saveDataWebPush(JSON.stringify({
          subscription: subscription,
          applicationKeys: {
            publicKey: this.applicationServerPublicKey.public,
            privateKey: this.applicationServerPublicKey.private
          }
        }))
      })
      .catch((err) => {
        console.log('Failed to subscribe the user: ', err)
        this.updateBtn()
      })
    },

    unsubscribeUser () {
      this.swRegistration.pushManager.getSubscription()
      .then((subscription) => {
        if (subscription) {
          return subscription.unsubscribe()
        }
      })
      .catch((error) => {
        console.log('Error unsubscribing', error)
      })
      .then(() => {
        this.updateSubscriptionOnServer(null)
        console.log('User is unsubscribed.')
        this.isSubscribed = false
        this.updateBtn()
      })
    },

    updateSubscriptionOnServer (subscription) {
      // TODO: Send subscription to application server
      console.log('updateSubscriptionOnServer', subscription)
      if (subscription) {
        this.subscriptionDetail = JSON.stringify(subscription)
        window.localStorage.setItem('server-subscription', JSON.stringify(subscription))
      } else {
        window.localStorage.removeItem('server-subscription')
      }
    },

    // ----------------------------------------------------------------------------
    // fonctions de generation du token pour le webPush
    // ----------------------------------------------------------------------------
    initialiseKeys () {
      console.log('--> initialiseKeys')
      this.updateKeys()
    },

    getNewKey () {
      this.clearKeys()
      this.updateKeys()
    },

    updateKeys () {
      // console.log('updateKeys')
      let storedKeys = this.getStoredKeys()
      let promiseChain = Promise.resolve(storedKeys)
      if (!storedKeys) {
        promiseChain = this.generateNewKeys()
        .then((newKeys) => {
          this.storeKeys(newKeys)
          this.applicationServerPublicKey = newKeys
          return newKeys
        })
      }

      return promiseChain.then((keys) => {
        this.applicationServerPublicKey = keys
        this.displayKeys(keys)
      })
    },

    displayKeys (keys) {
      if (document.querySelector('.js-public-key')) {
        const publicElement = document.querySelector('.js-public-key')
        publicElement.textContent = keys.public
      }
      if (document.querySelector('.js-private-key')) {
        const privateElement = document.querySelector('.js-private-key')
        privateElement.textContent = keys.private
      }

      this.refreshBtn = true
    },

    generateNewKeys () {
      return crypto.subtle.generateKey({name: 'ECDH', namedCurve: 'P-256'},
        true, ['deriveBits'])
      .then((keys) => {
        return this.cryptoKeyToUrlBase64(keys.publicKey, keys.privateKey)
      })
    },

    clearKeys () {
      window.localStorage.removeItem('server-keys')
    },

    storeKeys (keys) {
      window.localStorage.setItem('server-keys', JSON.stringify(keys))
    },

    getStoredKeys () {
      const storage = window.localStorage.getItem('server-keys')
      if (storage) {
        return JSON.parse(storage)
      }
      return null
    },

    base64UrlToUint8Array (base64UrlData) {
      const padding = '='.repeat((4 - base64UrlData.length % 4) % 4)
      const base64 = (base64UrlData + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')

      const rawData = window.atob(base64)
      const buffer = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        buffer[i] = rawData.charCodeAt(i)
      }
      return buffer
    },

    uint8ArrayToBase64Url (uint8Array, start, end) {
      start = start || 0
      end = end || uint8Array.byteLength

      const base64 = window.btoa(
        String.fromCharCode.apply(null, uint8Array.subarray(start, end)))
      return base64
        .replace(/\=/g, '') // eslint-disable-line no-useless-escape
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
    },

    cryptoKeyToUrlBase64 (publicKey, privateKey) {
      const promises = []
      promises.push(
        crypto.subtle.exportKey('jwk', publicKey)
        .then((jwk) => {
          const x = this.base64UrlToUint8Array(jwk.x)
          const y = this.base64UrlToUint8Array(jwk.y)

          const publicKey = new Uint8Array(65)
          publicKey.set([0x04], 0)
          publicKey.set(x, 1)
          publicKey.set(y, 33)

          return publicKey
        })
      )

      promises.push(
        crypto.subtle
          .exportKey('jwk', privateKey)
        .then((jwk) => {
          return this.base64UrlToUint8Array(jwk.d)
        })
      )

      return Promise.all(promises)
      .then((exportedKeys) => {
        return {
          public: this.uint8ArrayToBase64Url(exportedKeys[0]),
          private: this.uint8ArrayToBase64Url(exportedKeys[1])
        }
      })
    },

    sendNotif () {
      // console.log('sendNotif', this.subscriptionDetail.trim())
      const subscriptionString = this.subscriptionDetail.trim()
      const contentString = this.$t('contentNotif')
      const titleString = this.$t('titleNotif')

      this.saveDetails({
        subscription: subscriptionString,
        data: {
          title: titleString,
          content: contentString
        }
      })

      if (subscriptionString.length === 0) {
        return Promise.reject(new Error('Please provide a push subscription.'))
      }

      let subscriptionObject = null
      try {
        subscriptionObject = JSON.parse(subscriptionString)
      } catch (err) {
        return Promise.reject(new Error('Unable to parse subscription as JSON'))
      }

      if (!subscriptionObject.endpoint) {
        return Promise.reject(new Error('The subscription MUST have an endpoint'))
      }

      if (subscriptionObject.endpoint.indexOf('…') !== -1) {
        return Promise.reject(new Error('The subscription endpoint appears to be ' +
          'truncated (It has \'...\' in it).\n\nDid you copy it from the console ' +
          'in Chrome?')
        )
      }

      _watcheebox.sendWebPush(JSON.stringify({
        subscription: subscriptionObject,
        data: {
          title: titleString,
          content: contentString
        },
        applicationKeys: {
          publicKey: this.applicationServerPublicKey.public,
          privateKey: this.applicationServerPublicKey.private
        }
      }))
    },

    saveDetails (details) {
      window.localStorage.setItem('last-known-details', JSON.stringify(details))
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  computed: {
    // récupération des getters du store
    ...mapGetters('_User', ['user', 'fullName', 'userAvatar', 'account']),
    heightOfCard () {
      return 'height: ' + (window.innerHeight - 200) + 'px'
    }
  },

  mounted () {
    this.showFab = true
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push is supported')
      let dir = process.env.NODE_ENV === 'development' ? '/watcheezy/' : '/'
      navigator.serviceWorker.register(dir + 'service-worker.js', {
        scope: '.' // <--- THIS BIT IS REQUIRED
      }).then((swReg) => {
        console.log('Service Worker is registered', swReg.scope)
        this.souscriptionBtn = true
        this.swRegistration = swReg
        this.initializeUI()
      })
      .catch((error) => {
        console.error('Service Worker Error', error)
        this.souscriptionBtn = false
      })
    } else {
      console.warn('Push messaging is not supported')
      this.souscriptionBtn = false
    }
    this.initialiseKeys()
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
    if (this.$store.state._User.isMobile) {
      if (!this.$store.state._User.isMobileIOS) {
        this.hideShowNotifButton = false
      } else {
        this.hideShowNotifButton = true
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Profile.vue